// @flow
import fp from "lodash/fp"
import { createStore, applyMiddleware, compose } from "redux"
import reduxLogger from "redux-logger" // eslint-disable-line import/no-extraneous-dependencies
import thunk from "redux-thunk"
import Cookies from "js-cookie"
import { initClient } from "splitster-redux"

import reducer from "../services"
import promiseMiddleware from "common/services/middlewares/promise"
import crashReportMiddleware from "common/services/middlewares/crashReport"
import trackMiddleware from "common/services/middlewares/track"
import hydrateInitialState from "common/browser/hydrateInitialState"
import loggerColor from "common/utils/loggerColor"

const middleware = [thunk, promiseMiddleware, crashReportMiddleware, trackMiddleware]

const applied = fp.map(applyMiddleware, middleware)

if (__DEV__ && Cookies.get("showReduxLogs") === "true") {
  const logger = reduxLogger({
    collapsed: true,
    colors: { title: loggerColor },
  })

  applied.push(applyMiddleware(logger))
}

// https://github.com/zalmoxisus/redux-devtools-extension
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store: Store<*, *, *> = composeEnhancers(
  ...applied,
  window.LogRocket ? window.LogRocket.reduxEnhancer() : f => f,
)(createStore)(reducer, hydrateInitialState(window.__INITIAL_STATE__))

store.dispatch(
  initClient(
    window.__INITIAL_STATE__.splitsterConfig,
    window.__INITIAL_STATE__.splitsterUser,
    window.__INITIAL_STATE__.options.userId,
  ),
)

export default store

// Redux HMR
// =========

if (module.hot) {
  module.hot.accept("../services", () => {
    store.replaceReducer(reducer)
  })
}
